import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {
    access_token: '',
    _id: '',
  },
  gymId:'',
  visible: true
};

const commonReducerSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    updateUserCredentials(state, action) {
      return {
        ...state,
        user: {
          ...action.payload
        }
      };
    },
    logoutUser() {
      return {
        user: {},
        gymId:'',
        visible: true
      };
    },
    setVisible(state) {
      return {
        ...state,
        visible: !state.visible
      };
    },
    setGymId(state,action) {
      return {
        ...state,
        gymId: action.payload
      };
    },
  }
});

export const commonReducerAction = commonReducerSlice.actions;
export const commonReducers = commonReducerSlice.reducer;
